module.exports = __webpack_public_path__ + "static/1050580190-wide.c7d9e1b6.jpg";